<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    handleLoginEvent (data) {
      window.loading_screen.finish()
      this.$router.push(JSON.parse(data.state).path || '/')
      this.$store.commit('login', data.profile)
    }
  },
  created () {
    this.$auth.handleAuthentication()
  }
}
</script>
